import React from 'react';
import TeacherDashboard from './TeacherDashboard';

/**
 * Developer-only: shows what a teacher / faculty member would see.
 * Reuses the TeacherDashboard component in preview mode (yellow banner
 * + Exit link routing back to /developer).
 */
const FacultyPreview = () => (
  <TeacherDashboard previewMode exitPath="/developer" />
);

export default FacultyPreview;
